import styled from 'styled-components';
import { color, } from '../../legacy-tv-dls';

const Button = styled.button`
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 15px;
  margin: 4px;
  background: ${color.brand.primary['500']};
  display: inline-block;
  cursor: pointer;
  border-radius: 2px;
  &:hover {
    background: ${color.brand.primary['700']}
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js